export default __webpack_public_path__ + "static/media/impact-2.aef60da5.webp";